import { List, Map } from 'immutable';

import { TYPES } from './actions';
import { SESSION_DESTROY } from '../../actions';
import Logger from '../../../lib/Logger';

const initialState = Map({
  isLoading: false,
  activeItem: null,
  activeItemId: null,
  totalModules: 0,
  totalModuleCategories: 0,
  totalModuleLearningSteps: 0,
});

export default function learnings(state = initialState, action) {
  Logger.log(
    'debug',
    `[state.learnings.reducers] learnings(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case TYPES.SET_ACTIVE_ITEM_ID:
      return state.mergeDeep({
        activeItemId: action.id,
      });

    case TYPES.SET_ACTIVE_ITEM:
      return state.mergeDeep({
        activeItem: action.activeItem,
      });

    case TYPES.SUB_TOPIC_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.SUB_TOPIC_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
        subTopic: action.result,
      });

    case TYPES.SUB_TOPIC_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.LIST_TOPIC_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.LIST_TOPIC_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          results: {
            total: action.total,
            page_count: action.page_count,
            pages: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          lastUpdated: action.receivedAt,
        })
        .setIn(['results', action.limit, action.page], List(action.result));

    case TYPES.LIST_TOPIC_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_SERIE_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_SERIE_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          [`totalModuleSeries_${action.action}`]: action.total,
          moduleSeries: {
            [action.careGuideId]: {
              [action.partnershipId]: {
                [action.action]: {
                  pages: {
                    [action.order]: {
                      [action.limit]: {
                        [action.page]: null,
                      },
                    },
                  },
                },
              },
            },
          },
          lastUpdated: action.receivedAt,
        })
        .setIn(
          [
            'moduleSeries',
            action.careGuideId,
            action.partnershipId,
            action.action,
            'pages',
            action.order,
            action.limit,
            action.page,
          ],
          List(action.result)
        );

    case TYPES.MODULE_SERIE_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          [`totalModules_${action.action}`]: action.total,
          modules: {
            [action.careGuideId]: {
              [action.moduleSerieId]: {
                [action.action]: {
                  pages: {
                    [action.order]: {
                      [action.limit]: {
                        [action.page]: null,
                      },
                    },
                  },
                },
              },
            },
          },
          lastUpdated: action.receivedAt,
        })
        .setIn(
          [
            'modules',
            action.careGuideId,
            action.moduleSerieId,
            action.action,
            'pages',
            action.order,
            action.limit,
            action.page,
          ],
          List(action.result)
        );

    case TYPES.MODULE_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_CATEGORY_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_CATEGORY_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          moduleCategories: {
            [action.careGuideId]: {
              [action.partnershipId]: {
                totalModuleCategories: action.total,
                pages: {
                  [action.order]: {
                    [action.limit]: {
                      [action.page]: null,
                    },
                  },
                },
              },
            },
          },
          lastUpdated: action.receivedAt,
        })
        .setIn(
          [
            'moduleCategories',
            action.careGuideId,
            action.partnershipId,
            'pages',
            action.order,
            action.limit,
            action.page,
          ],
          List(action.result)
        );

    case TYPES.MODULE_CATEGORY_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_LEARNING_STEP_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_LEARNING_STEP_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          totalModuleLearningSteps: action.total,
          moduleLearningSteps: {
            [action.careGuideId]: {
              [action.moduleId]: {
                pages: {
                  [action.order]: {
                    [action.limit]: {
                      [action.page]: null,
                    },
                  },
                },
              },
            },
          },
          lastUpdated: action.receivedAt,
        })
        .setIn(
          [
            'moduleLearningSteps',
            action.careGuideId,
            action.moduleId,
            'pages',
            action.order,
            action.limit,
            action.page,
          ],
          List(action.result)
        );

    case TYPES.MODULE_LEARNING_STEP_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_LEARNING_STEP_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_LEARNING_STEP_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_LEARNING_STEP_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_LEARNING_STEP_PATCH_REQUEST:
      return state.mergeDeep({
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.MODULE_LEARNING_STEP_PATCH_SUCCESS:
      return state.mergeDeep({
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_LEARNING_STEP_PATCH_FAILURE:
      return state
        .mergeDeep({
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.MODULE_LEARNING_VIEW_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_LEARNING_VIEW_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_LEARNING_VIEW_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_LEARNING_VIEW_PATCH_REQUEST:
      return state.mergeDeep({
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.MODULE_LEARNING_VIEW_PATCH_SUCCESS:
      return state.mergeDeep({
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_LEARNING_VIEW_PATCH_FAILURE:
      return state
        .mergeDeep({
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case SESSION_DESTROY:
      return initialState;

    default:
      return state;
  }
}

Logger.log('silly', `state.learnings.reducers loaded.`);
